export default function linkPhoneFormat(value) {
  try {
    if (!value.trim()) {
      reject()
    }
    return String(value).replace(/\D+/g,'')
  } catch (e) {
    return value
  }
}
